<template>
  <div>
    <div class="Topic-title">物模型通信 Topic 列表</div>
    <div>
      <vxe-table
        row-id="id"
        :data="table"
        :sort-config="{ defaultSort: { field: 'function_type', order: 'asc' } }"
        align="left"
      >
        <vxe-table-column
          sortable
          field="function_type"
          show-overflow
          min-width="50"
          title="功能"
        ></vxe-table-column>
        <vxe-table-column
          field="topic"
          show-overflow
          min-width="420"
          title="Topic"
        ></vxe-table-column>
        <vxe-table-column
          field="topic_power"
          show-overflow
          min-width="80"
          title="操作权限"
        ></vxe-table-column>
        <vxe-table-column
          field="topic_desc"
          show-overflow
          min-width="220"
          title="描述"
        ></vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>

<script>
import { FUNCTION_TYPE, PUB_SUB } from "@/common/libs/Contains";

export default {
  components: {},
  props: {
    productKey: {},
  },
  data() {
    return {
      table: [],
    };
  },
  created() {
    this.getData();
  },

  methods: {
    async getData() {
      const subData = {
        app_id: sessionStorage.getItem("appid") || "",
        product_key: this.productKey,
        topic_type: "thing",
      };
      const res = await this.$post(
        "/td/td-iot-api/iot/product/topic/v1",
        subData,
        false
      );
      if (res.code === 0) {
        this.table = res.data;
        this.table.map((item) => {
          item.function_type = FUNCTION_TYPE[item.function_type];
          item.topic_power = PUB_SUB[item.topic_power];
        });
      } else {
        if (res.code == "100410") {
          setTimeout(() => {
            this.getData();
          }, 1000);
        } else {
          this.$message.error(res.msg);
        }
      }
    },
  },
  beforeDestroy() {},
};
</script>

<style lang="scss"></style>
